import { render, staticRenderFns } from "./BmvInput.vue?vue&type=template&id=53ed3943&scoped=true"
import script from "./BmvInput.vue?vue&type=script&lang=js"
export * from "./BmvInput.vue?vue&type=script&lang=js"
import style0 from "./BmvInput.vue?vue&type=style&index=0&id=53ed3943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed3943",
  null
  
)

export default component.exports